import {
    _charCount
} from './_charCount';

const allDevicesGiftboxMessageItem = () => {
    $('input[type=checkbox]').on('change', function(event) {
        if ($(this).prop("checked") == true) {
            $(this).closest('.giftbox-wrapper').find('textarea[id^=orderItemGiftMsgTxt]').removeAttr("disabled");
            $(this).closest('.giftbox-wrapper').children('.giftbox-message-wrapper').addClass('active');
        } else {
            $(this).closest('.giftbox-wrapper').find('textarea[id^=orderItemGiftMsgTxt]').attr("disabled", "disabled");
            $(this).closest('.giftbox-wrapper').children('.giftbox-message-wrapper').removeClass('active');
        }
    });
};

const allDevicesCharCountGiftBox = () => {
    if ($("#charactersremaining").length > 0) {
        _charCount();
        var elem = $("#charactersremaining");
        $("#gift-msg").charLimit(200, elem);
    }
};

export {
    allDevicesCharCountGiftBox,
    allDevicesGiftboxMessageItem
}
